 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"icons/icon-account-svg":"icons/icon-account-svg","icons/icon-charges-svg":"icons/icon-charges-svg","icons/icon-check-svg":"icons/icon-check-svg","icons/icon-circle-dot-svg":"icons/icon-circle-dot-svg","icons/icon-circle-svg":"icons/icon-circle-svg","icons/icon-client-svg":"icons/icon-client-svg","icons/icon-close-svg":"icons/icon-close-svg","icons/icon-configuration-svg":"icons/icon-configuration-svg","icons/icon-copy-svg":"icons/icon-copy-svg","icons/icon-cred-card-svg":"icons/icon-cred-card-svg","icons/icon-customers-svg":"icons/icon-customers-svg","icons/icon-dashboard-svg":"icons/icon-dashboard-svg","icons/icon-developer-svg":"icons/icon-developer-svg","icons/icon-direction-svg":"icons/icon-direction-svg","icons/icon-download-svg":"icons/icon-download-svg","icons/icon-edit-svg":"icons/icon-edit-svg","icons/icon-ellipsis-svg":"icons/icon-ellipsis-svg","icons/icon-fees-svg":"icons/icon-fees-svg","icons/icon-freearea-svg":"icons/icon-freearea-svg","icons/icon-hub-svg":"icons/icon-hub-svg","icons/icon-info-svg":"icons/icon-info-svg","icons/icon-invites-svg":"icons/icon-invites-svg","icons/icon-invoices-svg":"icons/icon-invoices-svg","icons/icon-learn-more-svg":"icons/icon-learn-more-svg","icons/icon-logoJPM-svg":"icons/icon-logoJPM-svg","icons/icon-logs-svg":"icons/icon-logs-svg","icons/icon-merchant-svg":"icons/icon-merchant-svg","icons/icon-mundi-svg":"icons/icon-mundi-svg","icons/icon-no-results-svg":"icons/icon-no-results-svg","icons/icon-notification-svg":"icons/icon-notification-svg","icons/icon-orders-svg":"icons/icon-orders-svg","icons/icon-pagarme-svg":"icons/icon-pagarme-svg","icons/icon-payment-links-svg":"icons/icon-payment-links-svg","icons/icon-payments-svg":"icons/icon-payments-svg","icons/icon-permission-svg":"icons/icon-permission-svg","icons/icon-pix-outline-svg":"icons/icon-pix-outline-svg","icons/icon-pix-svg":"icons/icon-pix-svg","icons/icon-plans-svg":"icons/icon-plans-svg","icons/icon-pos-svg":"icons/icon-pos-svg","icons/icon-profile-svg":"icons/icon-profile-svg","icons/icon-recurrence-svg":"icons/icon-recurrence-svg","icons/icon-security-svg":"icons/icon-security-svg","icons/icon-shop-svg":"icons/icon-shop-svg","icons/icon-statistics-svg":"icons/icon-statistics-svg","icons/icon-subscription-svg":"icons/icon-subscription-svg","icons/icon-subscriptions-svg":"icons/icon-subscriptions-svg","icons/icon-test-svg":"icons/icon-test-svg","icons/icon-trf-svg":"icons/icon-trf-svg","icons/icon-users-solid-svg":"icons/icon-users-solid-svg","icons/icon-users-svg":"icons/icon-users-svg","icons/icon-webhooks-config-svg":"icons/icon-webhooks-config-svg","icons/icon-webhooks-skeleton-svg":"icons/icon-webhooks-skeleton-svg","icons/icon-webhooks-svg":"icons/icon-webhooks-svg"}[chunkId]||chunkId) + ".chunk.js?id=" + {"icons/icon-account-svg":"d757d8fc5c91b1e4c99c","icons/icon-charges-svg":"ec328d0c04d7ac9634d5","icons/icon-check-svg":"36c5fc6754368b072738","icons/icon-circle-dot-svg":"a3f107d25114fe8a4cf2","icons/icon-circle-svg":"f36c7fea6c7409656149","icons/icon-client-svg":"4af5337eb81b77d90d2d","icons/icon-close-svg":"ec111704868ec0384971","icons/icon-configuration-svg":"69330e513c7328ae6e15","icons/icon-copy-svg":"be2e5240bb005251c4eb","icons/icon-cred-card-svg":"d30eff209b5574a3117a","icons/icon-customers-svg":"cd3e7ba872a654f16957","icons/icon-dashboard-svg":"39c20102b60200e6db76","icons/icon-developer-svg":"925ee2c54fe9e053b4c9","icons/icon-direction-svg":"abb8831109dce95da98f","icons/icon-download-svg":"3f82cc7bd07c30564ec2","icons/icon-edit-svg":"46a335962b0b37f6f93f","icons/icon-ellipsis-svg":"520a659104c603b67474","icons/icon-fees-svg":"936e46b35822d61605db","icons/icon-freearea-svg":"b4bdda96df08d5ee762f","icons/icon-hub-svg":"82c57d0773abae451e44","icons/icon-info-svg":"f0764bb3e4524dd59589","icons/icon-invites-svg":"88bf7252017fbbd4c645","icons/icon-invoices-svg":"77e1d54461a17cf46e01","icons/icon-learn-more-svg":"94d0c20978e201a30468","icons/icon-logoJPM-svg":"b80ccf56feb0d10dcf4a","icons/icon-logs-svg":"bf7ad10085a872711d76","icons/icon-merchant-svg":"46a3b2c89d7f1a18220c","icons/icon-mundi-svg":"0c52ca285d3c9faaf352","icons/icon-no-results-svg":"2d7fedfeab0a29b9d82d","icons/icon-notification-svg":"27b31bbb1859c443c6cc","icons/icon-orders-svg":"e517b9d6edd41646d758","icons/icon-pagarme-svg":"0104fd52d72467a46e08","icons/icon-payment-links-svg":"249954d96406214e3ab5","icons/icon-payments-svg":"cd3f1da64c648dbfdac1","icons/icon-permission-svg":"0f96a6928d66976eb2c2","icons/icon-pix-outline-svg":"3f9a6db433987ab846c5","icons/icon-pix-svg":"1e873280a8a06d6a9643","icons/icon-plans-svg":"66eaab464f3e86fc976e","icons/icon-pos-svg":"5b19bee14969957a9c89","icons/icon-profile-svg":"53b02f70a02b037e61a2","icons/icon-recurrence-svg":"e77a82ec7462656e217e","icons/icon-security-svg":"f1e4f679cf945b5a4b9b","icons/icon-shop-svg":"4da467a3f8a4b966fd75","icons/icon-statistics-svg":"92c80a4a5eabc3b12dbc","icons/icon-subscription-svg":"465b04142f2869fd21d8","icons/icon-subscriptions-svg":"0ffc04d1218331ff60f4","icons/icon-test-svg":"713a536991339e3b6eaf","icons/icon-trf-svg":"e0e09111701eabb48568","icons/icon-users-solid-svg":"ad0a76d0b9e5164f6439","icons/icon-users-svg":"eb89287e7a1edc52ac6d","icons/icon-webhooks-config-svg":"264603450e4b1af0a58b","icons/icon-webhooks-skeleton-svg":"d55acc57f1c2b90a73a0","icons/icon-webhooks-svg":"bb75a4bbe727ae89b09f"}[chunkId] + ""
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
